<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="items"
    :options.sync="paginate"
    :server-items-length="paginate.total"
    :footer-props="dataTableFooter"
    loading-text="กรุณารอสักครู่...">
    <template v-slot:[`item.socialMedias`]="{ item }">
      <div
        v-for="(social, index) in item.socialMedias"
        :key="`social-media-${index}`"
        class="d-flex align-center">
        <img
          v-if="socialMediaCompute(social).img"
          :src="socialMediaCompute(social).img"
          alt="icon"
          style="width: 24px; height: 24px;"
        />
        <p
          v-else
          style="margin-right: 8px;">
          {{ social.platform }}
        </p>
        <span>{{ socialMediaCompute(social, index).text }}</span>
      </div>
    </template>
    <template v-slot:[`item.address`]="{ item }">
      {{ getAddress(item.address) }}
    </template>
    <template
      v-slot:[`item.action`]="{ item }">
      <v-btn
        icon
        small
        @click="editCeleb(item)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        icon
        small
        @click="removeCeleb(item.id)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import IconInstagram from '@/assets/image/icons-ig.png'
import IconFacebook from '@/assets/image/icons-facebook.png'
import IconTiktok from '@/assets/image/icons-tiktok.png'
import IconLazada from '@/assets/image/icons-lazada.png'
import IconTwitter from '@/assets/image/icons-twitter.png'
import IconRedBook from '@/assets/image/icons-redbook.png'
import IconLemon8 from '@/assets/image/icons-lemon8.png'

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', width: '20%' },
        { text: 'Social Medias', value: 'socialMedias', width: '30%' },
        { text: 'Address', value: 'address', width: '40%' },
        { text: 'Action', value: 'action', sortable: false, width: '10%' }
      ],
      dataTableFooter: {
        itemsPerPageText: 'จำนวนแสดงต่อหน้า',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true
      },
      iconInstagram: IconInstagram,
      iconFacebook: IconFacebook,
      iconTiktok: IconTiktok,
      iconLazada: IconLazada,
      iconTwitter: IconTwitter,
      iconRedBook: IconRedBook,
      iconLemon8: IconLemon8
    }
  },
  computed: {
    paginate: {
      get () {
        return this.value
      },
      set (_value) {
        const value = { ..._value, page: _value.page || 1 }
        this.$emit('input', value)
      }
    }
  },
  methods: {
    removeCeleb (id) {
      this.$emit('click:remove', id)
    },
    editCeleb (item) {
      this.$emit('click:edit', item)
    },
    socialMediaCompute ({ accountName, platform }, index = null) {
      let text = ''
      if (index === 0) {
        text += `: ${accountName}`
      } else {
        text += `\n: ${accountName}`
      }

      const imageMap = {
        'instagram': this.iconInstagram,
        'facebook': this.iconFacebook,
        'tiktok': this.iconTiktok,
        'lazada': this.iconLazada,
        'x/twitter': this.iconTwitter,
        'redbook/xiaohongshu': this.iconRedBook,
        'lemon8': this.iconLemon8
      }

      const img = imageMap[platform] || null

      return { img, text }
    },
    getAddress (addressObj) {
      const fields = [
        addressObj.address,
        addressObj.address2,
        addressObj.states,
        addressObj.subDistrict,
        addressObj.district,
        addressObj.stateProvince,
        addressObj.province,
        addressObj.country,
        addressObj.postcode
      ]

      return fields.filter((field) => field).join(' ')
    }
  }
}
</script>

<style scoped>

</style>
